import config from '../nyConfig'

const ApiStaff = {
    "员工列表": new config({url: '/staff/staffList', showSuccessMessage: false, useToken: true}),
    "查询员工信息": new config({url: '/staff/staffListByIds', showSuccessMessage: false, useToken: true}),
    "公司员工列表": new config({url: '/staff/staffListByCompanyAndDepart', showSuccessMessage: false, useToken: true}),
    "公司部门列表": new config({url: '/staff/departListByCompany', showSuccessMessage: false, useToken: true}),
    "添加员工": new config({url: '/staff/staffAdd', showSuccessMessage: true, useToken: true}),
    "删除员工": new config({url: '/staff/staffDel', showSuccessMessage: true, useToken: true}),
    "重置密码": new config({url: '/staff/resetPwd', showSuccessMessage: true, useToken: true}),
    "导入员工": new config({url: '/staff/staffFileAdd', showSuccessMessage: true, useToken: true}),
    "编辑员工": new config({url: '/staff/staffEdit', showSuccessMessage: true, useToken: true}),
    "确认导入员工": new config({url: '/staff/staffFileAddConfirm', showSuccessMessage: true, useToken: true}),
    "员工回收站列表": new config({url: '/staff/staffRecycle', showSuccessMessage: false, useToken: true}),
    "冻结员工": new config({url: '/staff/staffFroze', showSuccessMessage: true, useToken: true}),
    "解冻员工": new config({url: '/staff/staffUnFroze', showSuccessMessage: true, useToken: true}),
    "导出员工": new config({url: '/staff/staffExport', showSuccessMessage: true, useToken: true}),
    "员工测评分数": new config({url: '/staff/staffScore', showSuccessMessage: false, useToken: true}),
    "员工测评折线": new config({url: '/staff/staffScoreLine', showSuccessMessage: false, useToken: true})
}

export default ApiStaff